// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useVendorAuth } from "../store/vendorAuthStore";

// export default function Topbar({ title = "Dashboard" }) {
//   const nav = useNavigate();
//   const { logout } = useVendorAuth();
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const handler = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, []);

//   const doLogout = () => {
//     logout?.();
//     nav("/login"); // ✅ Fixed
//   };

//   return (
//     <div style={{
//       display: "flex", alignItems: "center",
//       justifyContent: isMobile ? "flex-end" : "space-between",
//       padding: "14px 20px", background: "#fff",
//       borderBottom: "1px solid #eee", position: "relative",
//     }}>
//       {!isMobile && (
//         <>
//           <div style={{ width: 120 }} />
//           <h1 style={{
//             position: "absolute", left: "50%", transform: "translateX(-50%)",
//             margin: 0, fontSize: 22, fontWeight: 800, color: "#ff6a00",
//           }}>
//             {title}
//           </h1>
//         </>
//       )}
//       <div style={{ display: "flex", gap: 10 }}>
//         <button type="button" className="v-btn"
//           onClick={() => nav("/profile/edit")}> {/* ✅ Fixed */}
//           EditProfile
//         </button>
//         <button type="button" className="vhLogout" onClick={doLogout}>
//           Logout
//         </button>
//       </div>
//     </div>
//   );
// }

import React from "react";
import { useNavigate } from "react-router-dom";
import { useVendorAuth } from "../store/vendorAuthStore";

export default function Topbar({ title = "Dashboard" }) {
  const nav = useNavigate();
  const { logout } = useVendorAuth();


  const doLogout = () => {
    logout?.();
    nav("/login");
  };

  return (
    <div style={{
      display: "flex", alignItems: "center",
      justifyContent: "flex-end",
      padding: "14px 20px", background: "#fff",
      borderBottom: "1px solid #eee",
    }}>
      <div style={{ display: "flex", gap: 10 }}>
        <button type="button" className="vhLogout" onClick={doLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}